export const SOCIAL_USER_PROFILE_UPDATE_BEGIN =
  'SOCIAL_USER_PROFILE_UPDATE_BEGIN';
export const SOCIAL_USER_PROFILE_UPDATE_SUCCESS =
  'SOCIAL_USER_PROFILE_UPDATE_SUCCESS';
export const SOCIAL_USER_PROFILE_UPDATE_ERROR =
  'SOCIAL_USER_PROFILE_UPDATE_ERROR';
